import cn from 'classnames';
import { Image } from '../../../../../components/Image/Image';
import styles from './PaymentMethodCard.module.scss';
import { useEffect, useRef, useState } from 'react';
import {loadPaypalSdk} from '../../../../../services/loadPaypalSdk';
import { useNavigate } from 'react-router';
import { ampPaypalButtonClicked, ampPurchase, ampPurchaseStatus } from '../../../../../utils/AmplitudeEvents';
import { fbInitiateCheckout } from '../../../../../utils/FacebookEvents';
import { postBackCPAExchange } from '../../../../../utils/postBackCPAExchange';
export const PaymentMethodPayPal =({ data:planInfo,currency, method, status, onClick, onAvailable })=>{
  const [isAvailable, setIsAvailable] = useState(true);
  const [message, setMessage] = useState(null);
  const planId = planInfo?.paypalID?.[currency];
  const containerId = `paypal-button-${planId}`;
  const paypalRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    let paypalButtons = null;

    function renderButton() {
      if (window.paypal && planId && paypalRef.current) {
        // Очищаем контейнер
        paypalRef.current.innerHTML = "";
        paypalButtons = window.paypal.Buttons({
          style: {
            shape: 'rect',
            color: 'white',
            layout: 'vertical',
            label: 'paypal',
            tagline: false
          },
          createSubscription: function(data, actions) {
            return actions.subscription.create({
              plan_id: planId
            });
          },
          onApprove: function(data, actions) {
            const {subscriptionID} = data;
            ampPurchaseStatus('complete');
            postBackCPAExchange(subscriptionID);
            localStorage.setItem('planInfo', JSON.stringify(planInfo));
            ampPurchase({currency, payment_method: 'PayPal', price: data.salePrice/100, productId: planId, quantity: 1});
            navigate(`/registration?paypal_id=${subscriptionID}`)
          },
          onClick: function (data, actions) {
            ampPurchaseStatus('started');
            fbInitiateCheckout();
            ampPaypalButtonClicked(planInfo.title, planInfo.salePrice,currency)
          },
          onCancel : function (data, actions) {
            ampPurchaseStatus('decline');
          },
          onError: function (err) {
            const errorMsg = err?.message || String(err);
            console.error('PayPal error:', errorMsg);
            setMessage(errorMsg);
          }
        });
        paypalButtons.render(`#${containerId}`)
        .catch(() => {
          setIsAvailable(false);
        });
      }
    }

    loadPaypalSdk(renderButton);

    return () => {
      if (paypalButtons) paypalButtons.close();
      if (paypalRef.current) paypalRef.current.innerHTML = "";
    };
  }, [planId, containerId]);

  useEffect(() => {
    if (isAvailable && onAvailable) {
      onAvailable();
    }
  }, [isAvailable, onAvailable]);
  const  {name, icon, list, securedText} = method;




  

  if(!method || !planInfo || !isAvailable) return;
  return(
    <div className={cn(
      styles.wrapper,
      status ==='open' && styles.open
      )}
      onClick={isAvailable ? onClick : undefined}
      tabIndex={isAvailable ? 0 : -1}
      aria-disabled={!isAvailable}
      >
      <div className={styles.header}>
        <div className={styles.bullet}></div>
        {name && <div className={styles.methodName}>{name}</div>}
        {icon && <Image src={icon} className={styles.icon}/>}
      </div>
      <div className={styles.content}>
        {list && 
          <div className={styles.listWrapper}>
            <ul className={styles.list}>
              {list.map((item,index)=>{
                return <li key={index} className={styles.item}>{item}</li>
              })}
            </ul>
          </div>
        }
        {/* paymentElements */}
        <div className={styles.paymentElements}>
          <div id={containerId} ref={paypalRef}></div>
        </div>
        {/* paymentElements */}
        {message && <div className={styles.message}>{message}</div>}
        {securedText && <div className={styles.securedText}>{securedText}</div>}
      </div>
      
    </div>
  )
}